export const SET_LANCAMENTO = 'SET_LANCAMENTO'
export const SET_LANCAMENTOS = 'SET_LANCAMENTOS'
export const ADD_LANCAMENTOS = 'ADD_LANCAMENTOS'
export const UPDATE_LANCAMENTOS = 'UPDATE_LANCAMENTOS'
export const REMOVE_LANCAMENTOS = 'REMOVE_LANCAMENTOS'
export const OPEN_LANCAMENTO = 'OPEN_LANCAMENTO';
export const CLOSE_LANCAMENTO = 'CLOSE_LANCAMENTO';